import styled from "styled-components";
import { Button as BsButton } from "react-bootstrap";

export const Wrapper = styled.div`
  /* Tabs */
    .nav-tabs {
        position: sticky;
        top: 80px;
        z-index: 1000;
        background: white; /* importante para não ficar transparente */
    }
`;

export const CancelButton = styled(BsButton)`
  && {
    width: 177px;
    height: 32px;
    background: var(--white);
    border: 1px solid #00599c;
    color: #00599c;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    text-align: center;
    vertical-align: middle;
    border-radius: 4px;
    padding: 0 16px;
    gap: 8px;
  }

  &&:hover,
  &&:focus {
    background: #00599c;
    color: var(--white);
    border-color: #00599c;
  }
`;

export const IconButton = styled(BsButton)`
  && {
    width: 32px;
    height: 32px;
    background: #a0d6ff;
    border: none;
    color: #00599c;
    border-radius: 4px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &&:hover,
  &&:focus {
    background: #80bdf0;
    color: #00599c;
  }

  && svg {
    width: 16px;
    height: 16px;
  }
`;
